$(function() {

	var nextSlide = function() {
		// get current location
		var currentLeft = $(window).scrollLeft();

		// find the next 
		var images = $(".gallery .slide");
		for (var i = images.length - 1; i >= 0; i--) {
			var left = $(images[i]).position().left;

			// the (currentLeft + 1) is there to get rid of some issues we had with non-integer locations causing by the dynamic image sizing
			if (left <= (currentLeft + 1)) {
				nextImage = images[i + 1];
				if (nextImage != null) {
					$("html, body").animate({ scrollLeft: $(nextImage).position().left });
					return;
				}
				return;
			}
		}
	};
	
	var prevSlide = function() {
  	  	// get current location
	    var currentLeft = $(window).scrollLeft();
		
	    // find the previous 
		var images = $(".gallery .slide");
		for (var i = 0; i < images.length; i++) {
	    	var left = $(images[i]).position().left;
			
	    	if (left >= currentLeft) {
	    		prevImage = images[i - 1];
	    		if (prevImage != null) {
	        		$("html, body").animate({ scrollLeft: $(prevImage).position().left });
	        		return;
	    		}
	    		return;
	      	}
    	}
	};

	var imageClicked = function() {
		$("html, body").animate({ scrollLeft: $(this).position().left });
	};
	
	
	// listeners
	$(".gallery .slide").click(imageClicked);
	$("#next-slide").click(nextSlide);
	$("#prev-slide").click(prevSlide);


	//
	// gallery.show only
	//
	if ($('.gallery-container').length > 0) {
		$(document).keydown(function(e) {
			switch (e.which) {
				case 37:
					prevSlide();
					return false;
					break;
				case 39:
					nextSlide();
					return false;
					break;
			}
		});
		
		//
		// set up horizontal scrolling with mousewheel
		//
		// var mousewheelBound = false;
		// function checkBinding() {
		// 	var width = $(this).width();
		// 	if (width > 640 && mousewheelBound == false)
		// 	{
		// 		$("html, body").on("mousewheel", function(event) {
		// 			this.scrollLeft -= (event.deltaY * event.deltaFactor);
		// 			event.preventDefault();
		// 		});
		// 		mousewheelBound = true;
		// 	}
		// 	else if (width <= 640 && mousewheelBound == true)
		// 	{
		// 		$("html, body").off("mousewheel");
		// 		mousewheelBound = false;
		// 	}
	 	// }
		// checkBinding();
	 	// $(window).resize(function(){
	 	//     checkBinding();
	 	// });
	}
	
});





